import config from '@/config';
import { clearAuthSession } from '@/utils/authSession';

const installedClients = new WeakSet();
let expiredToken = null;

// Only the current application token can expire the application session.
// A delayed rejection of an older token must not log out a new session.
export function isCurrentSessionUnauthorized(error) {
  if (!error || !error.response || error.response.status !== 401) return false;
  const request = error.config;
  if (!request) return false;
  const token = localStorage.getItem('accessToken');
  if (!token) return false;
  const headers = request.headers || {};
  const key = Object.keys(headers).find(name => name.toLowerCase() === 'authorization');
  if (!key || headers[key] !== 'Bearer ' + token) return false;
  try {
    const api = new URL(config.apiBaseUrl, window.location.origin);
    const base = request.baseURL ? new URL(request.baseURL, window.location.origin) : null;
    const url = new URL(base && !request.url.startsWith('//') && !/^[a-z][a-z0-9+.-]*:/i.test(request.url)
      ? base.href.replace(/[/]$/, '') + '/' + request.url.replace(/^[/]/, '')
      : request.url, window.location.origin);
    return url.origin === api.origin && url.pathname.startsWith(api.pathname.replace(/[/]$/, '') + '/');
  } catch (e) { return false; }
}

export function installSessionExpiry(client) {
  if (installedClients.has(client)) return;
  installedClients.add(client);
  client.interceptors.response.use(response => response, error => {
    const headers = (error.config && error.config.headers) || {};
    const authKey = Object.keys(headers).find(name => name.toLowerCase() === 'authorization');
    if (expiredToken && !localStorage.getItem('accessToken') &&
        error.response && error.response.status === 401 &&
        headers[authKey] === 'Bearer ' + expiredToken) {
      error.sessionExpiryHandled = true;
    }
    if (isCurrentSessionUnauthorized(error)) {
      expiredToken = localStorage.getItem('accessToken');
      error.sessionExpiryHandled = true;
      clearAuthSession();
      // A pending automatic Microsoft flow must not immediately recreate the session.
      sessionStorage.removeItem('start_msal_login');
      sessionStorage.removeItem('ms_login_in_progress');
      window.location.replace('/');
    }
    return Promise.reject(error);
  });
}
